/**
 * The tenant an assistant conversation runs in: a Ziti network or a Frontdoor account. `kind` is the
 * collection segment the `ai-assistant` service hangs that tenant's chat and config endpoints off.
 */
export type AssistantScopeKind = 'networks' | 'frontdoors';

export interface AssistantScope {
    kind: AssistantScopeKind;
    id: string;
}

/** The panel title for each kind of assistant. */
export const ASSISTANT_TITLES: Record<AssistantScopeKind, string> = {
    networks: 'Network Assistant',
    frontdoors: 'Frontdoor Assistant',
};

/** What each kind of assistant works on, as it reads in running text ("manage your Frontdoor"). */
export const ASSISTANT_SUBJECTS: Record<AssistantScopeKind, string> = {
    networks: 'network',
    frontdoors: 'Frontdoor',
};

/** A stable key for a scope, for caches and per-scope transcripts. */
export function assistantScopeKey(scope: AssistantScope): string {
    return `${scope.kind}:${scope.id}`;
}

/** The scope's root in the `ai-assistant` service, e.g. `{base}/frontdoors/{id}`. */
export function assistantScopeUrl(baseUrl: string, scope: AssistantScope): string {
    return `${baseUrl}/${scope.kind}/${encodeURIComponent(scope.id)}`;
}
